module.exports = __webpack_public_path__ + "static/media/cretingDataset.481f99e7.gif";